<template>

</template>

<script>


export default {
  name: "SsamTalkFilterNoneLayout",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
